module.exports = __webpack_public_path__ + "static/media/holy-defiance-aura.273e2aa7.png";